'use strict';

import * as Utils from '../utils/utils.js';
import { emendo_map } from '../map.js';

class emendo_map_full extends emendo_map {

	constructor(map_id) {

		// Build HTML Structure
		const map_container = document.getElementById( map_id );
		const content = `
		<div id="map-full-sidebar">
			<header>
				<h1>${map_container.dataset.title}</h1>
				<p class="slogan">${map_container.dataset.subtitle}</p>
			</header>
			<div id="map-full-sidebar-container">
				<div id="map-full-sidebar-title"></div>
				<ul id="map-full-sidebar-cats" class="map-menu"></ul>
				<ul id="map-full-sidebar-places" class="map-menu"></ul>
			</div>
		</div>
		<div id="map-full-map"></div>
		<div id="map-full-infos">
			<div id="map-full-infos-close"></div>
			<div id="map-full-infos-place"></div>
			<div id="map-full-infos-posts"></div>
		</div>
		`;
		map_container.innerHTML = content;

		// Call emendo_map
		super( 'map-full-map', 16 );

		// Define variables
		this.place_type_id = 0;
		this.places = [];
		this.place_types = [];

		// Bind this to class functions
		this.getPlaces = this.getPlaces.bind(this);
		this.getPlaceTypes = this.getPlaceTypes.bind(this);
		this.updateMarkers = this.updateMarkers.bind(this);
		this.updateSidebar = this.updateSidebar.bind(this);
		this.updatePanel = this.updatePanel.bind(this);
		this.sidebardClickPlaceType = this.sidebardClickPlaceType.bind(this);
		this.sidebardClickPlace = this.sidebardClickPlace.bind(this);
		this.sidebardClickTitle = this.sidebardClickTitle.bind(this);

		// Create base map then ...
		super.create().then( () => {

			// Close Panel Event
			const map_full_panel_close = document.getElementById( 'map-full-infos-close' );
			map_full_panel_close.addEventListener("click", () => {
				const map_full_panel = document.getElementById( 'map-full-infos' );
				map_full_panel.classList.remove('active');
			});

			// Get data from API
			this.getPlaceTypes().then( (place_types) => {

				// Save place types
				this.place_types = place_types;

				this.getPlaces().then( (places) => {

					// Save places
					this.places = places;

					// Update sidebar and map
					this.updateMarkers( this.places );
					this.updateSidebar();

				}).catch( e => {} );

			}).catch( e => {
			} );

		});

	}

	/* Get Data from API
	-------------------------------------------------------------------------------------------------- */
	getPlaces() {

		return new Promise((resolve, reject) => {

			// Already have places then return
			if( this.places.length > 0 ) resolve();

			// Get Places
			fetch( rest_object.map_api_url + 'places?place-type=' + this.place_type_id, {
				method: "GET",
				cache: "no-cache",
				headers: { "Content-Type": "application/json; charset=utf-8"  }
			} )
			.then( response => { return response.json() } )
		    .then( places => resolve(places)  )
		    .catch(err => {
					reject(err);
		    });
		});
	}

	getPlaceTypes() {

		return new Promise((resolve, reject) => {

			// Already have places then return
			if( this.place_types.length > 0 ) resolve();

			fetch( rest_object.map_api_url + 'place-types', {
					method: "GET",
					cache: "no-cache",
					headers: { "Content-Type": "application/json; charset=utf-8"  }
			} )
			.then( response => { return response.json() } )
			.then( place_types => resolve(place_types)  )
			.catch(err => {
				reject(err);
			});
		});
	}


	/* Update markers
	-------------------------------------------------------------------------------------------------- */
	updateMarkers() {

		let places = [];

		if ( this.place_type_id == 0 ) {
			places = this.places;
		} else {
			this.places.forEach(p => {
				if( p.place_types.includes( this.place_type_id ) ) places.push(p);
			});
		}

		super.removeMarkers( );
		super.addMarkers( places, this.updatePanel.bind(this) );
	}

	/* Update Sidebar
	-------------------------------------------------------------------------------------------------- */
	updateSidebar() {

		// Get elements
		let map_full_sidebar_title = document.getElementById( 'map-full-sidebar-title' );
		let map_full_sidebar_cats = document.getElementById( 'map-full-sidebar-cats' );
		let map_full_sidebar_places = document.getElementById( 'map-full-sidebar-places' );

		// Empty the content
		map_full_sidebar_title.innerHTML = "";
		map_full_sidebar_cats.innerHTML = "";
		map_full_sidebar_places.innerHTML = "";

		/* Back Menu
		------------------------------------------ */
		let parent_place_type = null;
		this.place_types.map(function (t) {
		   if( t.id == this.place_type_id ) parent_place_type = t;
		}.bind(this));
		if( parent_place_type ) {
			map_full_sidebar_title.innerHTML = `<h4 id="menu-title" data-placetypeid="${parent_place_type.parent}"> ${parent_place_type.name} </h4>`;
		} else {
			map_full_sidebar_title.innerHTML = `<h4 id="menu-title" data-placetypeid="0"> Accueil </h4>`;
		}

		// Add clickHandler
		let menu_title = document.getElementById( 'menu-title' );
		menu_title.addEventListener("click", this.sidebardClickTitle , { once: true });

		/* Place Types
		------------------------------------------ */
		// Add place types to menu
		let menu_placetypes = ``;
		this.place_types.forEach(t => {
			if(t.parent == this.place_type_id) menu_placetypes += `<li class="menu-placetype" data-placetypeid="${t.id}"> ${t.name} </li>`;
		});
		map_full_sidebar_cats.innerHTML = menu_placetypes;

		// Add clickHandler
		let btns_placetypes = document.getElementsByClassName( 'menu-placetype' );
		for ( let btn of btns_placetypes ) {
			btn.addEventListener("click", this.sidebardClickPlaceType , { once: true });
		}

		/* Places
		------------------------------------------ */
		// Add places to menu
		let menu_places = ``;
		this.places.forEach(p => {

			let icon_img = super.getPlaceIcon(p);

			if( this.place_type_id == 0 ) {
				if( p.place_types.length == 0 ) menu_places += `<li class="menu-place" data-placeid="${p.id}"> ${icon_img} ${p.title} </li>`;
			} else {
				if( p.place_types.includes( this.place_type_id ) ) menu_places += `<li class="menu-place" data-placeid="${p.id}"> ${icon_img} ${p.title} </li>`;
			}

		});
		map_full_sidebar_places.innerHTML = menu_places;

		// Add clickHandler
		let btns_places = document.getElementsByClassName( 'menu-place' );
		for ( let btn of btns_places ) {
			btn.addEventListener("click", this.sidebardClickPlace );
		}

	}

	/* Sidebar Events
	-------------------------------------------------------------------------------------------------- */
	sidebardClickTitle(e) {
		this.place_type_id = Number(e.target.dataset.placetypeid);
		this.updateMarkers();
		this.updateSidebar();
	}

	sidebardClickPlaceType(e) {
		this.place_type_id =  Number(e.target.dataset.placetypeid);
		this.updateMarkers();
		this.updateSidebar();
	}

	sidebardClickPlace(e) {
		const place_id = Number(e.target.dataset.placeid);
		this.updatePanel(place_id);
	}


	/* ShowPanel
	-------------------------------------------------------------------------------------------------- */
	updatePanel(place_id) {

		// Get class context
		var $this = this;
		const map_full_panel = document.getElementById( 'map-full-infos' );
		const map_full_place = document.getElementById( 'map-full-infos-place' );
		const map_full_posts = document.getElementById( 'map-full-infos-posts' );

		// Remove panel content
		map_full_place.innerHTML = '';
		map_full_posts.innerHTML = '';

		// Get marker and place
		const marker = this.markers[place_id];
		const place = marker.dataset;

		// Center map on marker
		this.map.setView(marker._latlng);

		// Append place info to the Panel
		map_full_place.innerHTML = place.info;

		// Get linked posts
		fetch( rest_object.map_api_url + 'places/' + place_id + '/posts', {
				method: "GET",
				cache: "no-cache",
				headers: { "Content-Type": "application/json; charset=utf-8"  }
		} )
		.then( response => { return response.json() } )
	    .then( posts => {
			let content = '';
			posts.forEach(post => {
				content += post.info;
			});
			map_full_posts.innerHTML = content;
		} )
	    .catch(err => {
	    });

		// Focus on the marker
		super.focusMarker(place_id);

		map_full_panel.classList.add('active');

	}

}

Utils.IsInDOM( 'map-full' )
    .then(element => {
		new emendo_map_full( element.id );
    })
	.catch( e => {} );
